// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/glass-surface.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "time-tracker-app")
// Destination      : packages/fleet/ui/src/glass-surface.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo time-tracker-app
//     node fleet/fleet.ts check --repo time-tracker-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { type Component, type JSX, splitProps } from "solid-js";
import { cn } from "@time-tracker/shared";

interface GlassSurfaceProps extends JSX.HTMLAttributes<HTMLDivElement> {
  children?: JSX.Element;
  borderEdge?: "teal" | "purple" | "accent" | "none";
  disableBlur?: boolean;
  ref?: (el: HTMLDivElement) => void;
}

export const GlassSurface: Component<GlassSurfaceProps> = (props) => {
  const [local, rest] = splitProps(props, [
    "children",
    "class",
    "borderEdge",
    "disableBlur",
    "style",
  ]);

  const borderClass = () => {
    if (local.borderEdge === "teal") {
      return "border-l-success";
    }
    if (local.borderEdge === "purple" || local.borderEdge === "accent") {
      return "border-l-accent";
    }
    return "border-l-transparent";
  };

  const hasCustomBorder = () => {
    const cls = local.class ?? "";
    return /border-(?:primary|transparent|danger)/u.test(cls);
  };

  return (
    <div
      ref={props.ref}
      class={cn(
        "relative overflow-hidden border-[1.5px] bg-[var(--glass)] rounded-[var(--radius-xl)]",
        !hasCustomBorder() && "border-[var(--glass-border)]",
        !local.disableBlur && "backdrop-blur-xl",
        local.class,
      )}
      style={local.style}
      {...rest}
    >
      {/* Top Highlight line */}
      <div
        class="absolute top-0 left-0 right-0 h-[1px] bg-white/10"
        style={{ "background-color": "var(--glass-highlight)" }}
      />

      {/* Border Edge (Optional) */}
      <div
        class={cn("h-full w-full p-px", local.borderEdge !== "none" && "border-l-4", borderClass())}
      >
        {local.children}
      </div>
    </div>
  );
};
